import { DeliveryMethod } from '../models/Order';

const getIconForDeliveryMethod = (deliveryMethod: DeliveryMethod): string => {
  const aws = process.env.REACT_APP_AWS_URL;
  return `${aws}/assets/logos/delivery-methods/${deliveryMethod}.svg`;
};

export default getIconForDeliveryMethod;
